import { CreditCard, Model } from '@/models';

export class Customer extends Model {
	public cc_primary = new CreditCard();
	public cc_secondary = new CreditCard();
	public customer: number = 0;
	public other_id: null | number | string = null;
}
